import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $balanceOperations,
  $totalCountOfBalanceOperations,
  balanceOperationListMounted,
  getBalanceOperations,
} from './model'
import { BalanceOperationRequest } from './types'

export const useBalanceOperationList = () => {
  React.useEffect(() => {
    balanceOperationListMounted({
      limit: 10,
      page: 1,
      orderBy: 'createdAt',
      orderDirection: '-',
      searchText: '',
      searchedColumn: '',
    })
  }, [])

  const onChangeBalanceOperationList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }: BalanceOperationRequest) => {
    balanceOperationListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
      filters,
    })
  }
  const loading = useStore(getBalanceOperations.pending)

  const balanceOperations = useStore($balanceOperations)
  const totalCountOfBalanceOperations = useStore($totalCountOfBalanceOperations)
  return {
    balanceOperations,
    totalCountOfBalanceOperations,
    loading,
    onChangeBalanceOperationList,
  }
}
